var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#FFF9F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#FF6D34",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2083 15.982H10.3809C9.72376 15.982 9.19043 16.5153 9.19043 17.1724V22.8272C9.19043 23.4843 9.72376 24.0177 10.3809 24.0177H13.2083L17.9452 28.0308C18.719 28.6867 19.9047 28.1367 19.9047 27.1224V12.8772C19.9047 11.8629 18.7178 11.3129 17.9452 11.9689L13.2083 15.982Z",
    stroke: "#FF6D34",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7107 24.7356C26.094 23.8761 27.0476 22.088 27.0476 20.0058C27.0476 17.9237 26.094 16.1344 24.7107 15.2642",
    stroke: "#FF6D34",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2441 28.4106C30.3965 26.5594 31.8096 23.488 31.8096 20.0034C31.8096 16.5141 30.3941 13.4403 28.2382 11.5903",
    stroke: "#FF6D34",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/soundIcon.28e794336fc81a9c7f07b279f98fccf3.svg";
export { ForwardRef as ReactComponent };